<template>
    <div class="sa-free-page">
        <div class="sa-free-page-header">
            <b-card class="sa-card" header="Dettagli Laboratorio" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice</label>
                        <b-form-input v-model="jsonData.codice"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione</label>
                        <b-form-input v-model="jsonData.descrizione"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            pathResource: "/rsastruttureprovenienza",
            id: "-1",
            jsonData: {},
            struttura: null,
            filtroPresidi: {},
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonData = response.data.data;
                        this.$emit("afterLoadData");
                    })
                    .catch(() => {});
            }
        },
    },
};
</script>
